import { Neo } from "@singularsystems/neo-react";
import { NeoReport, Report, ReportUIRenderer, ReportUIRendererProps } from "@singularsystems/neo-reporting";
import { ReportCategory } from "../../Reports/ReportCategory";
import { ComponentType } from "react";
import { AppService, Types } from "../../../App/Services/AppService";
import { FileUtils } from "@singularsystems/neo-core";
import SingularInfoCriteria from "./SingularInfoCriteria";

@NeoReport("SingularInfo", { category: ReportCategory.Exports })
export default class SingularInfoReport extends Report<SingularInfoCriteria> {

    constructor() {
        super(SingularInfoCriteria);
    }

    public renderCriteria() {
        return <div>
            <Neo.GridLayout md={2}>
                <Neo.FormGroup bind={this.criteria.meta.runDate} />
            </Neo.GridLayout>
        </div>;
    }

    get uiRenderer(): ComponentType<ReportUIRendererProps> {
        return SingularInfoReportUIRenderer;
    }
}

class SingularInfoReportUIRenderer extends ReportUIRenderer {
    
    renderActionButtons(): React.ReactNode {
        
        return <>
            {super.renderActionButtons()}
            <Neo.Button
                icon="file"
                variant="secondary"
                onClick={() => this.downloadFile()}>
                    Download Text File
            </Neo.Button>
            <Neo.Button
                icon="file-archive"
                variant="secondary"
                onClick={() => this.downloadZipFile()}>
                    Download Zip File
            </Neo.Button>
        </>
    }

    private async downloadFile() {
        const apiClient = AppService.get(Types.Domain.ApiClients.ExportApiClient);

        const response = await this.props.taskRunner.waitFor(apiClient.getSingularInfoFile((this.report as SingularInfoReport).criteria.toJSObject()), {allowPost: true});

        FileUtils.showSaveFile(response);
    }

    private async downloadZipFile() {
        const apiClient = AppService.get(Types.Domain.ApiClients.ExportApiClient);

        const response = await this.props.taskRunner.waitFor(apiClient.getSingularInfoZipFile((this.report as SingularInfoReport).criteria.toJSObject()), {allowPost: true});

        FileUtils.showSaveFile(response);
    }
}